import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

import closeSurveyBg from 'assets/images/pulseSurveys/close-survey-bg.png'

export const CloseSurveyWrapper = styled.div`
    grid-area: close-survey;
    min-height: 140px;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 8px;
    border-radius: 15px;
    border: 1.5px solid ${({ theme }) => theme.colors.primaryGray2};
    position: relative;
    background-image: url(${closeSurveyBg});
    background-repeat: no-repeat;
    background-position: 80px 20px;

    .dds-button {
        align-self: flex-start;
    }

    .dds-button[disabled] {
        width: 40px;
        height: 40px;
    }
`

export const Details = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const Title = styled.h3`
    margin: 0;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p01Semibold')}
`

export const Description = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.secondary500};
    white-space: pre-wrap;

    ${getFontStyle('p03Regular')}
`
